import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { BasefieldV2Component } from '@app/formly/types/v2/basefield-v2/basefield-v2.component';
import { filterDDWithCode } from '@app/formly/types/v2/typeahead-v2/typeahead-filters';
import { AirportsService } from '@app/shared/services/airports/airports.service';
import { DropdownItem } from '@voyagu/radar-design-system';

@Component({
  selector: 'airport-field',
  templateUrl: './airport-field.component.html',
  styleUrls: ['./airport-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AirportFieldComponent extends BasefieldV2Component implements OnInit {
  airportsService = inject(AirportsService);
  cdRef = inject(ChangeDetectorRef);

  items$ = this.airportsService.getAirportsAsDropDownItems();
  selectedItem: DropdownItem | null = null;
  filterCallback = filterDDWithCode;
  ready = false;

  ngOnInit() {
    this.items$.subscribe((items) => {
      this.selectedItem = this.resolveSelectedItem(items);
      this.ready = true;
      this.cdRef.markForCheck();
    });
  }

  selectOption(item: DropdownItem) {
    if (!item?.value) {
      this.selectedItem = null;
      this.formControl.setValue('');
      this.formControl.markAsDirty();
      return;
    }

    this.selectedItem = item;
    this.formControl.setValue(item.value);
    this.formControl.markAsDirty();
  }

  resolveSelectedItem(items: DropdownItem[]) {
    const initial = this.props.initial ?? this.formControl.value;

    if (!initial) {
      return null;
    }

    return items.find((item) => String(item.value) === String(initial)) ?? null;
  }
}
